import React, { useState, useEffect } from "react";

import { Wrapper } from "./styled";
import { GAME_STEPS, LEVEL_TIME } from "../constants";

import Header from "../Header";
import Cover from "../Cover";
import Instructions from "../Instructions";
import Dossier from "../Dossier";
import Topic from "../Topic";
import Summary from "../Summary";
import Intro from "../Intro";
import Game from "../Game";
import Result from "../Result";

function App() {
  const [gameStep, setGameStep] = useState(GAME_STEPS.cover);
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(LEVEL_TIME);
  const [started, setStarted] = useState(false);
  const [topicIds, setTopicIds] = useState([]);
  const [character, setCharacter] = useState(null);
  const [sad, setSad] = useState(true);

  const showHeader = () =>
    gameStep !== GAME_STEPS.cover &&
    (gameStep !== GAME_STEPS.result || (gameStep === GAME_STEPS.result && sad));

  useEffect(() => {
    if (started && time > 0) {
      setTimeout(() => {
        setTime(time - 1);
      }, 1000);
    }

    if (started && time === 0) {
      setGameStep(GAME_STEPS.result);
    }
  }, [started, time]);

  const handleNext = score => {
    if (score) {
      handleIncrementScore(score);
    }

    switch (gameStep) {
      case GAME_STEPS.cover:
        setGameStep(GAME_STEPS.instructions);
        break;
      case GAME_STEPS.instructions:
        setGameStep(GAME_STEPS.dossier);
        break;
      case GAME_STEPS.dossier:
        setGameStep(GAME_STEPS.topic);
        break;
      case GAME_STEPS.topic:
        setGameStep(GAME_STEPS.summary);
        break;
      case GAME_STEPS.summary:
        setGameStep(GAME_STEPS.intro);
        break;
      case GAME_STEPS.intro:
        setGameStep(GAME_STEPS.game);
        break;
      case GAME_STEPS.game:
        setGameStep(GAME_STEPS.result);
        break;
      default:
        setGameStep(GAME_STEPS.cover);
    }
  };

  const handleIncrementScore = s => setScore(score + (s || 1));

  const handleRepeat = () => {
    setGameStep(GAME_STEPS.cover);
    setScore(0);
    setTime(LEVEL_TIME);
    setStarted(false);
    setTopicIds([]);
    setCharacter(null);
    setSad(true);
  };

  return (
    <Wrapper>
      {showHeader() && <Header score={score} time={time} />}
      {gameStep === GAME_STEPS.cover && <Cover onNext={handleNext} />}
      {gameStep === GAME_STEPS.instructions && (
        <Instructions onNext={handleNext} />
      )}
      {gameStep === GAME_STEPS.dossier && (
        <Dossier
          onNext={handleNext}
          onIncrement={handleIncrementScore}
          onSetCharacter={setCharacter}
        />
      )}
      {gameStep === GAME_STEPS.topic && (
        <Topic onSetTopicIds={setTopicIds} onNext={handleNext} />
      )}
      {gameStep === GAME_STEPS.summary && (
        <Summary
          onNext={handleNext}
          character={character}
          topicIds={topicIds}
        />
      )}
      {gameStep === GAME_STEPS.intro && <Intro onNext={handleNext} />}
      {gameStep === GAME_STEPS.game && (
        <Game
          onStart={() => setStarted(true)}
          onNext={handleNext}
          onIncrement={handleIncrementScore}
          onSetSad={setSad}
        />
      )}
      {gameStep === GAME_STEPS.result && (
        <Result
          score={score}
          sad={sad}
          onNext={handleNext}
          onRepeat={handleRepeat}
        />
      )}
    </Wrapper>
  );
}

export default App;
